
const list = resolve => require(['@/components/exhibit/list'],resolve);
const detail = resolve => require(['@/components/exhibit/detail'],resolve);
export default [
	{
		path : 'exhibit/list',
		name : 'exhibitList',
		meta : {
			title : '陈列订货',
			searchDisabled : false
		},
		component : list
	},
	{
		path : 'exhibit/detail',
		name : 'exhibitDetail',
		meta : {
			title : '陈列订货详情',
			searchDisabled : false,
			activeName : 'exhibitList'
		},
		component : detail
	}
]



// WEBPACK FOOTER //
// ./src/router/exhibit/index.js